import { render, staticRenderFns } from "./VConfirm.vue?vue&type=template&id=9e2e82ac"
import script from "./VConfirm.vue?vue&type=script&lang=js"
export * from "./VConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports